<template>
    <b-button @click="downloadFile" variant="outline-primary">
        <img src="@/assets/icons/download.svg" />
        <div>
            {{ $t('download') }}
        </div>
    </b-button>
</template>

<script>
import api from '@/services/api'

export default {
    name: 'DownloadBtn',
    methods: {
        downloadFile() {
            let activePeriods = this.$store.getters['periods']
            api.get('objectives/download', {
                responseType: 'arraybuffer',
                params: { periods: activePeriods }
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')

                link.href = url
                link.setAttribute('download', 'CoBlue_Okrs.xlsx')
                document.body.appendChild(link)
                link.click()
            });
        }
    },
    i18n: {
        messages: {
            'en-US': {
                download: 'Download',
            },
            'es-ES': {
                download: 'Descargar',
            },
            'pt-BR': {
                download: 'Download',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 0.55rem 0.5rem;
    height: 2.6rem !important;
    align-self: center;
    margin-left: auto;
    font-weight: 700;
    font-size: 0.9rem;
    color: #009ada;
    border: solid 2px #009ada;
}

.btn:hover,
.btn:active {
    background-color: transparent !important;
    color: #009ada !important;
    border-color: #009ada !important;
}

@media only screen and (max-width: 1300px) {
    .label {
        display: none;
    }
}
</style>
